import { PolicyWithRules } from "@pages/policy/types";
// TODO: These constants aren't really used anywhere except to check against a slug,
// but we can use these in the future for writing tests
export const BLOCKING_POLICY_NAME: string = "Rule Board - Block column";
export const AUDIT_POLICY_NAME: string = "Rule Board - Audit column";
export const PR_COMMENTS_POLICY_NAME: string =
  "Rule Board - PR Comments column";
export const MONITOR_POLICY_NAME: string = "Rule Board - Monitor column";

export const BLOCKING_POLICY: PolicyWithRules = {
  name: BLOCKING_POLICY_NAME,
  slug: "rule-board-block",
  rules: [],
  is_default: false,
  notifications: [],
  blocking: true,
  description: "",
  repos: [],
  pr_comments: true,
  overrides: [],
};

export const AUDIT_POLICY: PolicyWithRules = {
  name: AUDIT_POLICY_NAME,
  slug: "rule-board-audit",
  rules: [
    // If you update these, also update them in backend!
    { type: "pack", id: "default", overrides: [] },
  ],
  is_default: false,
  notifications: [],
  blocking: false,
  description: "",
  repos: [],
  pr_comments: false,
  overrides: [],
};

export const PR_COMMENTS_POLICY: PolicyWithRules = {
  name: PR_COMMENTS_POLICY_NAME,
  slug: "rule-board-pr-comments",
  rules: [],
  is_default: false,
  notifications: [],
  blocking: false,
  description: "",
  repos: [],
  pr_comments: true,
  overrides: [],
};

export const NOLICY_POLICIES = [
  // in the order that they should be displayed
  AUDIT_POLICY,
  PR_COMMENTS_POLICY,
  BLOCKING_POLICY,
];

export const NOLICY_SLUG_TO_APP_COLUMN_NAME: Record<string, string> = {
  "rule-board-block": "Block",
  "rule-board-audit": "Monitor",
  "rule-board-pr-comments": "Comment",
};

export const NOLICY_SLUG_FROM_CARD_NAME: Record<string, string> = {
  blocking: "rule-board-block",
  audit: "rule-board-audit",
  prComments: "rule-board-pr-comments",
};
